import React from 'react';
import styles from './WhoWeAre.module.css';

const WhoWeAre2 = () => {
  return (
    <div style={{
      position: 'relative', 
      height: '110vh', 
      overflow: 'hidden', 
      margin: 0, 
      paddingBottom: '0'
    }}>
      <img
        src="/whoweare.jpg" 
        alt="Descriptive alt text"
        style={{
          width: '100%', 
          height: '100%', 
          objectFit: 'cover',
        }}
      />

      <div style={{
        position: 'absolute', 
        bottom: 0,  
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundColor: 'white',
        padding: '4rem', 
        borderRadius: '1rem 1rem 0 0', 
        width: '60%', 
      }}>
        <div style={{ textAlign: 'center', marginBottom: '4rem' }}> {/* Center the logo */}
          <img 
            src="/logo.png"  // Assuming logo.png is in the public folder
            alt="Logo"
            style={{ maxWidth: '100%' }} // Ensure logo scales down if needed
          />
        </div>

        <div style={{  
          position: 'relative', 
          overflow: 'visible' 
        }}>
          <h2 style={{ 
            position: 'absolute', 
            bottom: '-1.5em', // Adjust as needed to control overlap
            left: '50%', 
            transform: 'translateX(-50%)',
            color: '#438B4D',
            fontSize: 60,
            textAlign: 'center',

        fontFamily: 'NewZen-Bold',
          }}> 
            More than dating
          </h2>
        </div>
      </div>
    </div>);
};

export default WhoWeAre2;